<template>
    <section class="flex justify-between w-full items-center">
        <p
            :class="{ 'text-red-error': inErrorState && (totalSelectionsMade !== totalSteps)}"
            class="text-base font-semibold"
            v-if="totalSteps > 0"
        >
            {{ totalSelectionsMade }}/{{ totalSteps }} {{ $t('COMPLETED') }}
        </p>

        <view-all-button />
    </section>
</template>

<script>
    import allStores from '../stores/all';

    import ViewAllButton from './buttons/ViewAllButton.vue';

    export default {
        mixins: [allStores],

        components: {
            ViewAllButton,
        },

        computed: {
            totalSteps() {
                return this.customizerStore.totalSteps;
            },

            totalSelectionsMade() {
                return this.customizerStore.totalSelectionsMade;
            },

            selectionsComplete() {
                return this.customizerStore.selectionsComplete;
            },

            currentGroup() {
                return this.customizerStore.currentGroup;
            },

            panelsInErrorState() {
                return this.customizerStore.panelsInErrorState;
            },

            inErrorState() {
                return this.panelsInErrorState.includes('Main');
            },
        },
    };
</script>
